import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Building2Icon, GlobeIcon, UsersIcon, PhoneIcon, MailIcon, LinkedinIcon, ArrowLeftIcon, BarChart3Icon, ClockIcon, CheckCircleIcon, XCircleIcon, SendIcon } from 'lucide-react';
export const LeadScoutDetails = () => {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  // Dataset matching the leads from LeadScout.tsx
  const leadsData = {
    1: {
      company: 'Tech Innovate GmbH',
      industry: 'IT-Dienstleistungen',
      size: '50-100',
      location: 'München',
      revenue: '€5M - €10M',
      website: 'www.techinnovate.de',
      phone: '+49 89 123456',
      email: 'kontakt@techinnovate.de',
      linkedin: 'linkedin.com/company/techinnovate',
      score: 92,
      contacts: [{
        name: 'Dr. Marcus Weber',
        position: 'CTO',
        email: 'm.weber@techinnovate.de'
      }, {
        name: 'Sarah Schmidt',
        position: 'Head of Innovation',
        email: 's.schmidt@techinnovate.de'
      }]
    },
    2: {
      company: 'Digital Solutions AG',
      industry: 'Software-Entwicklung',
      size: '100-250',
      location: 'Berlin',
      revenue: '€10M - €25M',
      website: 'www.digitalsolutions.de',
      phone: '+49 30 789012',
      email: 'info@digitalsolutions.de',
      linkedin: 'linkedin.com/company/digitalsolutions',
      score: 87,
      contacts: [{
        name: 'Dr. Thomas Müller',
        position: 'CEO',
        email: 't.mueller@digitalsolutions.de'
      }, {
        name: 'Anna Klein',
        position: 'Head of Sales',
        email: 'a.klein@digitalsolutions.de'
      }, {
        name: 'Michael Berg',
        position: 'Technical Director',
        email: 'm.berg@digitalsolutions.de'
      }]
    },
    3: {
      company: 'Future Systems GmbH',
      industry: 'IT-Beratung',
      size: '25-50',
      location: 'Hamburg',
      revenue: '€2.5M - €5M',
      website: 'www.futuresystems.de',
      phone: '+49 40 345678',
      email: 'kontakt@futuresystems.de',
      linkedin: 'linkedin.com/company/futuresystems',
      score: 85,
      contacts: [{
        name: 'Lisa Wagner',
        position: 'Managing Director',
        email: 'l.wagner@futuresystems.de'
      }]
    },
    4: {
      company: 'Quantum Innovations GmbH',
      industry: 'Hardware',
      size: '250-500',
      location: 'Frankfurt',
      revenue: '€25M - €50M',
      website: 'www.quantum-innovations.de',
      phone: '+49 69 901234',
      email: 'info@quantum-innovations.de',
      linkedin: 'linkedin.com/company/quantum-innovations',
      score: 81,
      contacts: [{
        name: 'Dr. Robert Fischer',
        position: 'CTO',
        email: 'r.fischer@quantum-innovations.de'
      }, {
        name: 'Julia Bauer',
        position: 'Head of R&D',
        email: 'j.bauer@quantum-innovations.de'
      }, {
        name: 'Martin Wolf',
        position: 'Innovation Manager',
        email: 'm.wolf@quantum-innovations.de'
      }, {
        name: 'Sandra Richter',
        position: 'Technical Lead',
        email: 's.richter@quantum-innovations.de'
      }]
    },
    5: {
      company: 'SmartTech Solutions',
      industry: 'IT-Sicherheit',
      size: '10-25',
      location: 'Köln',
      revenue: '€1M - €2.5M',
      website: 'www.smarttech-solutions.de',
      phone: '+49 221 567890',
      email: 'kontakt@smarttech-solutions.de',
      linkedin: 'linkedin.com/company/smarttech-solutions',
      score: 78,
      contacts: [{
        name: 'Peter Schmidt',
        position: 'CEO',
        email: 'p.schmidt@smarttech-solutions.de'
      }, {
        name: 'Maria Koch',
        position: 'Security Expert',
        email: 'm.koch@smarttech-solutions.de'
      }]
    }
  };
  const leadData = leadsData[id] || leadsData[1]; // Fallback to first lead if ID not found
  // Replace the contacts constant with leadData.contacts
  const contacts = leadData.contacts;
  // Generic data that's the same for all leads
  const activities = [{
    type: 'visit',
    description: 'Website besucht - Produktseite',
    date: 'Heute, 14:30',
    status: 'success'
  }, {
    type: 'download',
    description: 'Whitepaper heruntergeladen',
    date: 'Gestern, 16:45',
    status: 'success'
  }, {
    type: 'email',
    description: 'Email-Kampagne geöffnet',
    date: 'Vor 2 Tagen',
    status: 'success'
  }, {
    type: 'contact',
    description: 'Kontaktversuch - Keine Antwort',
    date: 'Vor 5 Tagen',
    status: 'failed'
  }];
  // Get next 3 companies for similar companies section
  const similarCompanies = Object.entries(leadsData).filter(([key]) => key !== id).slice(0, 3).map(([_, company]) => ({
    name: company.company,
    industry: company.industry,
    score: company.score
  }));
  return <div className="space-y-6" data-id="element-287">
      <div className="flex items-center justify-between" data-id="element-288">
        <button onClick={() => navigate('/')} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-289">
          <ArrowLeftIcon size={16} className="mr-2" data-id="element-290" />
          Zurück zur Übersicht
        </button>
        <button className="px-4 py-2 bg-[#17B978] rounded-lg text-sm font-medium text-white flex items-center hover:bg-[#148F5F]" data-id="element-291">
          <SendIcon size={16} className="mr-2" data-id="element-292" />
          Kontakt aufnehmen
        </button>
      </div>
      <div className="grid grid-cols-3 gap-6" data-id="element-293">
        <div className="col-span-2 space-y-6" data-id="element-294">
          <div className="bg-white rounded-lg shadow" data-id="element-295">
            <div className="p-6" data-id="element-296">
              <div className="flex items-start justify-between" data-id="element-297">
                <div className="flex items-start space-x-4" data-id="element-298">
                  <div className="p-3 bg-blue-100 rounded-lg" data-id="element-299">
                    <Building2Icon size={24} className="text-blue-500" data-id="element-300" />
                  </div>
                  <div data-id="element-301">
                    <h1 className="text-2xl font-bold text-gray-900" data-id="element-302">
                      {leadData.company}
                    </h1>
                    <p className="text-gray-500 mt-1" data-id="element-303">{leadData.industry}</p>
                  </div>
                </div>
                <div className="flex items-center space-x-2" data-id="element-304">
                  <div className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium" data-id="element-305">
                    Lead Score: {leadData.score}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6 mt-6" data-id="element-306">
                <div className="space-y-4" data-id="element-307">
                  <div className="flex items-center text-gray-600" data-id="element-308">
                    <UsersIcon size={16} className="mr-2" data-id="element-309" />
                    {leadData.size} Mitarbeiter
                  </div>
                  <div className="flex items-center text-gray-600" data-id="element-310">
                    <GlobeIcon size={16} className="mr-2" data-id="element-311" />
                    {leadData.location}
                  </div>
                  <div className="flex items-center text-gray-600" data-id="element-312">
                    <BarChart3Icon size={16} className="mr-2" data-id="element-313" />
                    {leadData.revenue} Jahresumsatz
                  </div>
                </div>
                <div className="space-y-4" data-id="element-314">
                  <a href={`https://${leadData.website}`} target="_blank" rel="noopener noreferrer" className="flex items-center text-blue-500 hover:text-blue-600" data-id="element-315">
                    <GlobeIcon size={16} className="mr-2" data-id="element-316" />
                    {leadData.website}
                  </a>
                  <div className="flex items-center text-gray-600" data-id="element-317">
                    <PhoneIcon size={16} className="mr-2" data-id="element-318" />
                    {leadData.phone}
                  </div>
                  <div className="flex items-center text-gray-600" data-id="element-319">
                    <MailIcon size={16} className="mr-2" data-id="element-320" />
                    {leadData.email}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow" data-id="element-321">
            <div className="p-6" data-id="element-322">
              <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-323">
                Aktivitäten
              </h2>
              <div className="space-y-4" data-id="element-324">
                {activities.map((activity, index) => <div key={index} className="flex items-start space-x-3 pb-4 border-b border-gray-100 last:border-0 last:pb-0" data-id="element-325">
                    <div className={`p-2 rounded-full ${activity.status === 'success' ? 'bg-green-100' : 'bg-red-100'}`} data-id="element-326">
                      {activity.status === 'success' ? <CheckCircleIcon size={16} className="text-green-500" data-id="element-327" /> : <XCircleIcon size={16} className="text-red-500" data-id="element-328" />}
                    </div>
                    <div className="flex-1" data-id="element-329">
                      <p className="text-sm text-gray-800" data-id="element-330">
                        {activity.description}
                      </p>
                      <div className="flex items-center mt-1 text-xs text-gray-500" data-id="element-331">
                        <ClockIcon size={12} className="mr-1" data-id="element-332" />
                        {activity.date}
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-6" data-id="element-333">
          <div className="bg-white rounded-lg shadow" data-id="element-334">
            <div className="p-6" data-id="element-335">
              <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-336">
                Kontakte
              </h2>
              <div className="space-y-4" data-id="element-337">
                {contacts.map((contact, index) => <div key={index} className="p-4 border border-gray-100 rounded-lg" data-id="element-338">
                    <div className="flex items-start space-x-3" data-id="element-339">
                      <div className="p-2 bg-blue-100 rounded-full" data-id="element-340">
                        <UsersIcon size={16} className="text-blue-500" data-id="element-341" />
                      </div>
                      <div data-id="element-342">
                        <h3 className="text-sm font-medium text-gray-900" data-id="element-343">
                          {contact.name}
                        </h3>
                        <p className="text-xs text-gray-500 mt-1" data-id="element-344">
                          {contact.position}
                        </p>
                        <a href={`mailto:${contact.email}`} className="text-xs text-blue-500 hover:text-blue-600 mt-2 inline-block" data-id="element-345">
                          {contact.email}
                        </a>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow" data-id="element-346">
            <div className="p-6" data-id="element-347">
              <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-348">
                Ähnliche Unternehmen
              </h2>
              <div className="space-y-4" data-id="element-349">
                {similarCompanies.map((company, index) => <div key={index} className="p-4 border border-gray-100 rounded-lg hover:bg-gray-50 cursor-pointer" data-id="element-350">
                    <div className="flex items-center justify-between" data-id="element-351">
                      <div data-id="element-352">
                        <h3 className="text-sm font-medium text-gray-900" data-id="element-353">
                          {company.name}
                        </h3>
                        <p className="text-xs text-gray-500 mt-1" data-id="element-354">
                          {company.industry}
                        </p>
                      </div>
                      <div className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs" data-id="element-355">
                        Score: {company.score}
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};